import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { servicesAPI, generalAPI } from '../utils/api';
import toast from 'react-hot-toast';
import './PostJob.css';

export default function PostService() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({
    title: '', description: '', requirements: '', deliverables: '',
    sport_category_id: '', price: '', price_type: 'fixed',
    delivery_days: '', tags: ''
  });

  useEffect(() => {
    generalAPI.getCategories().then(res => setCategories(res.data.data || []));
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.title || !form.description || !form.price) {
      toast.error('يرجى ملء الحقول الإلزامية');
      return;
    }
    setSubmitting(true);
    try {
      const res = await servicesAPI.create(form);
      toast.success('تم نشر الخدمة بنجاح!');
      navigate(`/services/${res.data.data.id}`);
    } catch (err) {
      toast.error(err.response?.data?.message || 'فشل نشر الخدمة');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="post-page">
      <div className="post-page-header">
        <div className="post-header-content">
          <h1>إضافة خدمة جديدة</h1>
          <p>قدّم خدماتك الرياضية للمؤسسات والأفراد</p>
        </div>
      </div>

      <div className="post-form-container">
        <form onSubmit={handleSubmit} className="post-form">
          <div className="form-section">
            <h2 className="form-section-title">معلومات الخدمة</h2>
            <div className="form-grid">
              <div className="form-group full-width">
                <label className="form-label">عنوان الخدمة *</label>
                <input type="text" name="title" className="form-input"
                  placeholder="مثال: تصوير احترافي للمباريات الرياضية"
                  value={form.title} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label className="form-label">التصنيف الرياضي</label>
                <select name="sport_category_id" className="form-input"
                  value={form.sport_category_id} onChange={handleChange}>
                  <option value="">اختر التصنيف</option>
                  {categories.map(c => (
                    <option key={c.id} value={c.id}>{c.name_ar || c.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">نوع السعر</label>
                <select name="price_type" className="form-input"
                  value={form.price_type} onChange={handleChange}>
                  <option value="fixed">سعر ثابت</option>
                  <option value="hourly">بالساعة</option>
                  <option value="daily">باليوم</option>
                  <option value="negotiable">قابل للتفاوض</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">السعر (ر.س) *</label>
                <input type="number" name="price" className="form-input"
                  placeholder="500" min="0"
                  value={form.price} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label className="form-label">مدة التسليم (أيام)</label>
                <input type="number" name="delivery_days" className="form-input"
                  placeholder="3" min="1"
                  value={form.delivery_days} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">الكلمات المفتاحية</label>
                <input type="text" name="tags" className="form-input"
                  placeholder="تصوير، رياضة، فيديو"
                  value={form.tags} onChange={handleChange} />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2 className="form-section-title">تفاصيل الخدمة</h2>
            <div className="form-group">
              <label className="form-label">وصف الخدمة *</label>
              <textarea name="description" className="form-input" rows="6"
                placeholder="اشرح خدمتك بالتفصيل وما الذي تقدمه..."
                value={form.description} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label className="form-label">المتطلبات من العميل</label>
              <textarea name="requirements" className="form-input" rows="4"
                placeholder="ما الذي تحتاجه من العميل قبل البدء..."
                value={form.requirements} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className="form-label">ما ستحصل عليه</label>
              <textarea name="deliverables" className="form-input" rows="4"
                placeholder="ما الذي سيتلقاه العميل عند اكتمال الخدمة..."
                value={form.deliverables} onChange={handleChange} />
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-outline" onClick={() => navigate(-1)}>إلغاء</button>
            <button type="submit" className="btn btn-primary btn-lg" disabled={submitting}>
              {submitting ? 'جاري النشر...' : '✨ نشر الخدمة'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
